'use client';

import { SectionHeader, LineItemsTable } from '../shared';

interface LineItem {
  cdk_id?: string | null;
  cdk?: string | null;
  product?: { name: string } | null;
  product_name?: string | null;
  product_sku?: string | null;
  description?: string | null;
  quantity?: number | null;
  quantity_offered?: number | null;
  unit_price?: number | null;
  total?: number | null;
  source_line_sid?: string | null;
  source_line_label?: string | null;
}

interface ItemsSectionProps {
  items: LineItem[] | null | undefined;
  showTotal?: boolean;
  label?: string | null;
  // Entity's own server-computed total (e.g. costplan_details'
  // amount_total) — see LineItemsTable's `total` prop docstring.
  total?: number | null;
  // Click-to-focus — OFF by default, only turned on by the Cost Plan
  // rail surface (mode3/mode11). See LineItemsTable's `interactive` prop.
  interactive?: boolean;
  focusedSourceLineSid?: string | null;
  onRowClick?: (item: LineItem) => void;
}

export function ItemsSection({
  items,
  showTotal = false,
  label,
  total,
  interactive = false,
  focusedSourceLineSid = null,
  onRowClick,
}: ItemsSectionProps) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div>
      <SectionHeader title={label || 'LINE ITEMS'} count={items.length} />
      <LineItemsTable
        items={items}
        showTotal={showTotal}
        total={total}
        interactive={interactive}
        focusedSourceLineSid={focusedSourceLineSid}
        onRowClick={onRowClick}
      />
    </div>
  );
}
